export default "__VITE_ASSET__eb34213d__"